module.exports = __webpack_public_path__ + "static/subset-UniNeueRegular-Italic-20567cde3dd354c5c3a2211c01d5d47a.woff";